import { AccountEnvironment } from "..";
import { Page } from "../components/page/Page";
import { useAccountAlerts } from "../utils/useAccountAlerts";
import {
    useEnvironment,
} from "@keycloak/keycloak-ui-shared";
import { usePromise } from "../utils/usePromise";
import {
    Button,
    DataList,
    DataListItem,
    DataListItemRow,
    DataListContent,
    Grid,
    GridItem,
    Spinner,
    Split,
    SplitItem,
} from "@patternfly/react-core";
import { MouseEventHandler, MouseEvent, useState } from 'react';
import { useTranslation } from "react-i18next";
import { CallOptions } from "../api/methods";
import { request } from "../api/request";
import { parseResponse } from "../api/parse-response";

type OneConfig = {
  accountUrl: string;
  portalUrl: string;
  dn_status: string;
}

export type OneConfigRepresentation = any & {
  oneConfig: OneConfig;
};

function getOneConfig({ signal, context, }: CallOptions): Promise<OneConfigRepresentation>;

async function getOneConfig({
                                 signal,
                                 context,
                               }: CallOptions): Promise<OneConfigRepresentation> {
  const response = await request(`../one-account-api/dotnet/config`, context, {
    signal,
  });
  return parseResponse<OneConfigRepresentation>(response);
}

export const MyPage = () => {
  const { t } = useTranslation();
  const context = useEnvironment<AccountEnvironment>();
  const [oneConfig, setOneConfig] = useState<OneConfigRepresentation>();
  usePromise((signal) => getOneConfig({ signal, context }), setOneConfig);

  const {
    // addAlert,
    addError,
  } = useAccountAlerts();

  const onOneLinking = (async (event: MouseEvent<HTMLButtonElement>)  => {
    console.info("Clicked onOneLinking", event);
    try {
      const response = await fetch(`/realms/${context.environment.realm}/one-account-api/dotnet/token`);
      if (!response.ok) {
        throw new Error(`レスポンスステータス: ${response.status}`);
      }

      const result = await response.json();
      const token = result.encoded;
      const HOST_URL = oneConfig.accountUrl;
      window.location.href = `${HOST_URL}/RegistForm.php/oneLink/token=${token}/`
    } catch (error) {
      console.error(error);
      addError("fetch error", error);
    }
  }) as unknown as MouseEventHandler<HTMLButtonElement>;

  type OneService = {
    key: string,
    title: string;
    used?: boolean;
    logo?: string;
  }

  // @ts-ignore
  const actions: { [keys: string]:  (MouseEventHandler<HTMLButtonElement>) } = {
    "dotnet_cs": onOneLinking,
  }

  const OneServices: OneService[] = [
    {key: "dotnet_cs", title: t("dotnet_cs_title"), logo: `${context.environment.resourceUrl}/img/services/dotnet_cs_logo.svg`},
  ];

  if (!oneConfig) {
    return <Spinner />;
  }

  let dn_status: string;
  let dn_goto_label: string;
  switch (oneConfig.dn_status) {
    case "10":
      dn_status = t("status_temporary_waiting");
      dn_goto_label = "";
      break;
    case "11":
      dn_status = t("status_temporary_waiting_invite");
      dn_goto_label = "";
      break;
    case "19":
      dn_status = t("status_temporary_waiting_expired");
      dn_goto_label = "";
      break;
    case "2":
      dn_status = t("status_used");
      dn_goto_label =  t("dotnet_cs_used");
      break;
    case "9":
      dn_status = t("status_waiting_delete");
      dn_goto_label = "";
      break;
    case "0":
      dn_status = t("status_unuse");
      dn_goto_label =  t("dotnet_cs_unuse");
      break;
    default:
      dn_status = t("status_unknown");
      dn_goto_label = "";
      break;
  }

  return (
    <Page
      title={t("mypage_title")}
      description=""
    >
        <DataList
            id="services-list"
            aria-label={t("mypage_title")}
        >
        {OneServices.map((service) => (
                <DataListItem
                    key={service.key}
                    aria-labelledby="services-list"
                    data-testid="services-list-item"
                    isExpanded={true}
                >
                    <DataListItemRow className="pf-v5-u-align-items-center">
                        <DataListContent
                            aria-label="device-sessions-content"
                            className="pf-v5-u-flex-grow-1"
                        >
                            <Grid hasGutter>
                                <GridItem span={2} rowSpan={2}>
                                    <img src={service.logo} alt="service logo" className="one-services-logo" />
                                </GridItem>
                                <GridItem sm={8} md={9} span={10}>
                                    <strong className="one-services-title">{t(service.title)}</strong>
                                </GridItem>
                                <GridItem sm={8} md={9} span={10}>
                                    <Split hasGutter className="pf-v5-u-mb-lg">
                                        <SplitItem>
                                            <label className="one-services-status">{dn_status}</label>
                                        </SplitItem>
                                        {service.key in actions && dn_goto_label !== "" && (
                                            <SplitItem>
                                            <Button
                                                type="button"
                                                variant="secondary"
                                                onClick={actions[service.key]}
                                                className="one-services-button"
                                            >
                                                {dn_goto_label}
                                            </Button>
                                            </SplitItem>
                                        )}
                                    </Split>
                                </GridItem>
                            </Grid>
                        </DataListContent>
                    </DataListItemRow>
                </DataListItem>
        ))}
        </DataList>
    </Page>
  );
};

export default MyPage;
